import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  Grid,
  Switch,
  FormControlLabel,
  Typography,
} from "@mui/material";

import ApiEndpoints from "../network/ApiEndPoints";
import { postJsonData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import Loader from "../component/loading-screen/Loader";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";

const IGNORE_KEYS = ["id", "user_id", "created_at", "updated_at"];

const formatLabel = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toUpperCase();

const EditUserService = ({ open, handleClose, data, onSuccess }) => {
  const [request, setRequest] = useState(false);
  const [services, setServices] = useState({});

  // 🔹 Build services dynamically from data
  useEffect(() => {
    if (!data) return;

    const dynamicServices = {};
    Object.keys(data).forEach((key) => {
      if (!IGNORE_KEYS.includes(key) && typeof data[key] === "number") {
        dynamicServices[key] = Boolean(data[key]);
      }
    });

    setServices(dynamicServices);
  }, [data]);

  // 🔹 Toggle handler
  const handleToggle = (key) => {
    setServices((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // 🔹 Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: data.id,
      ...Object.fromEntries(
        Object.entries(services).map(([k, v]) => [k, v ? 1 : 0])
      ),
    };

    postJsonData(
      ApiEndpoints.UPDATE_USER_SERVICES,
      payload,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message);
        onSuccess();
      },
      (err) => apiErrorToast(err)
    );
  };

  if (!data) return null;

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{ width: 420 }} className="sm_modal">
        <Loader loading={request} />
        <ModalHeader title="Edit User Services" handleClose={handleClose} />

        <Box component="form" id="editUserServiceForm" onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                User ID: {data.user_id}
              </Typography>
            </Grid>

            {/* 🔥 DYNAMIC SERVICE TOGGLES */}
            {Object.keys(services).map((key) => (
              <Grid item xs={12} key={key}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={services[key]}
                      onChange={() => handleToggle(key)}
                      color="primary"
                    />
                  }
                  label={formatLabel(key)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mr: 2 }}>
          <ModalFooter
            form="editUserServiceForm"
            type="submit"
            btn="Update"
            disable={request}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default EditUserService;
